// Shared styling for the Select/MultiSelect controls that live inside a
// RuleListRow's value slot (both the Conditions and the Actions sections of the
// rule drawer). The control should read as inline text-with-dropdown rather
// than a boxed form field, and stay compact (11px) so every row matches.
//
// Mantine v7 selectors: a single Select shows its value via `input`, while a
// MultiSelect renders chosen values as `pill`s (inside `pillsList`) and the
// typed search text in `inputField`; the chevron lives in `section`. Keep every
// text surface at 11px so single- and multi-select values render identically.
export const inlineSelectStyles = {
  root: { width: '100%' },
  input: {
    border: 'none',
    background: 'transparent',
    padding: 0,
    minHeight: 'unset',
    height: 'auto',
    fontSize: '11px',
    lineHeight: 1.2,
    color: 'inherit',
  },
  wrapper: { margin: 0 },
  section: { width: 18 },
  pill: { fontSize: '11px' },
  inputField: {
    fontSize: '11px',
    padding: 0,
    minHeight: 'unset',
  },
}

// Spread onto a Select/MultiSelect to get the inline, compact treatment in one
// shot. Spread it first so per-call props (data/value/onChange/etc.) still win.
export const inlineSelectProps = {
  variant: 'unstyled' as const,
  size: 'xs' as const,
  styles: inlineSelectStyles,
}
